<template>
  <div class="footerBox">


    <div class="kw1400">
      <div class="footerTop">
        <div class="footerTopPad">
          <div class="footerTopLeft" v-html="configData.copyright">
            <!-- 中瓷控股股份有限公司<br/>
            沪ICP备16006927号-1 -->



          </div>
          <div class="footerTopCenter">
            <span class="telTextRow"><i class="icon-dianhua iconfont"></i>全国客户服务热线：<b>{{configData.hotLine}}</b></span>
            <div class="footerPhoneShow pt10">
              <a href="/contact" class="footerLxBtn"><i class="iconfont icon-fuwudiqiu"></i>联系我们</a>
            </div>
          </div>
          <div class="footerTopRight">
            {{configData.slogan}}
          </div>
        </div>
      </div>

      <div class="footerMain">
        <div class="footerMainLeft">
          <div class="footerNav">
            <div class="footerNavItem" v-for="(item,index) in configData.nav">
              <a :href="item.url || '/article/'+item.id" class="footerNavItemBtn" @click="navClick(index)">{{item.name}}</a>
              <div class="footerNavItemSon" :class="{'active': item.open}">
                <div>
                  <a :href="itemSon.url || '/article/'+itemSon.id" v-for="(itemSon,sonIndex) in item.childs">{{itemSon.name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footerMainRight">
          <div class="footerMedium">
            <span class="footerMediumTitle">follow China holdings</span>
            <div class="footerMediumRight">
              <a href="javascript:;" class="footerMediumIcon iconfont icon-weixin1" v-if="configData.wechat_qrcode" style="color: #2ac546;"><div class="footerMediumIconPic"><img :src="configData.wechat_qrcode" /></div></a>
              <a href="javascript:;" class="footerMediumIcon iconfont icon-zhongci" v-if="configData.qrcode" style="color: #AD7C59;"><div class="footerMediumIconPic"><img :src="configData.qrcode" /></div></a>
            </div>
          </div>


          <div class="footerMediumMain">
            <!-- <div class="footerMediumRow">
              <i class="iconfont icon-youxiang"></i>
              zc@china-holddings.cn
            </div>

            <div class="footerMediumRow">
              <i class="iconfont icon-dizhi"></i>
              <div class="footerMediumRowText">
                <span>上海 - </span>普陀区绿洲中环中心1号楼12F
              </div>
              <div class="footerMediumRowText">
                <span>深圳 - </span>南山区西丽街道打石一路深圳国际创新谷6栋
              </div>

              <div class="footerMediumRowText">
                <span>北京 - </span>海淀区中关村南四街四号4号楼中国科学院软件研究所
              </div>
            </div> -->

            <div class=" phoneShow">
              <div v-if="contact.content_h5" v-html="contact.content_h5"></div>
              <div v-else v-html="contact.content_pc"></div>
            </div>
            <div class="pcShow" v-html="contact.content_pc"></div>
          </div>

        </div>
      </div>

    </div>




  </div>
</template>

<script>
import { categoryView,getConfig } from '@/api/web'
export default {
  data () {
    return {
      contact:{},
      configData:[],
      nav:[]
    }
  },

  updated() {


  },
  mounted() {
    categoryView({category_id:51}).then(res => {
        this.contact = res.data
    })

    getConfig().then(res => {
      this.configData = res.data
      for(var i = 0 ; i < this.configData.nav.length; i++){
        this.configData.nav[i].open = false
      }
      //-------
      var newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.type = 'image/x-icon';
      newLink.href = this.configData.icon || '';

      // 获取并移除原有的 favicon link（如果有多个，可能需要更精确的选择器）
      var oldLinks = document.querySelectorAll('link[rel="icon"]');
      for (var i = 0; i < oldLinks.length; i++) {
        oldLinks[i].parentNode.removeChild(oldLinks[i]);
      }

      // 将新创建的 link 插入到 head 中
      document.head.appendChild(newLink);
      //-------

      this.$store.commit("setWebConfig", this.configData)

    })
  },

  methods:{

  }
}
</script>
<style>

</style>





// WEBPACK FOOTER //
// src/components/footerBar.vue